import { MAX_FOCUS_FRAMES } from '@/constants/videoTutorials';
import nextFrame from '@/utils/functions/nextFrame/nextFrame';

// MtxButton (Stencil, shadow DOM sans delegatesFocus) : le <button> focusable est dans son shadowRoot,
// rendu seulement une fois le composant prêt.
const waitForActionButton = async (host: Element) => {
  if ('componentOnReady' in host && typeof host.componentOnReady === 'function') await host.componentOnReady();
  for (let frame = 0; frame < MAX_FOCUS_FRAMES && !host.shadowRoot?.querySelector('button'); frame += 1) {
    await nextFrame();
  }
};

export default waitForActionButton;
